﻿

export function fFormatDate(dateString) {
    const qDate = new Date(dateString);

    var dd = qDate.getDate();
    var mm = qDate.getMonth() + 1;
    var yyyy = qDate.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    return `${dd}.${mm}.${yyyy}`;
}


export function fJSONParse(input) {
    var sResult = input;
    try {
        var canParse = true;
        try {
            JSON.parse(input);
        } catch (e) {
            canParse = false;
        }
        if (canParse) {
            sResult = JSON.parse(input);
        }
    }
    catch (err) {
        console.log('fJSONParse: ' + err.message);
    }
    return sResult;
}

function getLocalStorageSizeInKB() {
    let total = 0;
    for (let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) continue;
        const value = localStorage.getItem(key);
        total += key.length + value.length;
    }
    // UTF-16: 2 bytes per character
    return (total * 2) / 1024; // Größe in KB
}

export async function fMessageCache(qMod, qAuftragsliste, qId) {
    let sResult = '';
 
    try {
        let ladriverMessagesCache = fJSONParse(localStorage.getItem("ladriver-messages-cache")) || [];    
        switch (qMod) {
            case 'Find':
         
                if (qId && qId !== '') {
                    const msgId = parseInt(qId);
                    const cachedMessage = ladriverMessagesCache.find(msg => msg.ID === msgId);
                    if (cachedMessage) {
                        sResult = cachedMessage;                  
                    }
                }
                break;

            case 'Download':
               
                if (qId && qAuftragsliste && qAuftragsliste.length > 0) {
                    const msgId = parseInt(qId);

                    for (let i = 0; i < qAuftragsliste.length; i++) {
                        const tour = qAuftragsliste[i].tour || [];
                        for (let ii = 0; ii < tour.length; ii++) {
                            const messages = tour[ii].messages || [];
                            for (let iii = 0; iii < messages.length; iii++) {
                                const currentMessage = messages[iii];
                                if (currentMessage.text && currentMessage.ID === msgId) {
                                    const isInCache = ladriverMessagesCache.some(msg => msg.ID === msgId);
                                    if (!isInCache) {
                                        const postData = JSON.stringify({ id: msgId });
                                        const baseUrl = window.location.hostname === 'localhost'
                                            ? 'http://localhost:61131'
                                            : '.';

                                        
                                        try {
                                            const response = await fetch(`${baseUrl}/apiMessages.ashx`, {
                                                method: "POST",
                                                body: postData,
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "x-la-token": `["${qAuftragsliste[i].token}"]`
                                                }
                                            });

                                            if (response.ok) {
                                                const data = await response.json();
                                                if (data && data.length >= 1) {
                                                    ladriverMessagesCache.push(data[0]);

                                                    const jsonString = JSON.stringify(ladriverMessagesCache);
                                                    const sizeInBytes = new Blob([jsonString]).size;
                                                    const itemSizeInKB = sizeInBytes / 1024;
                                                    const storageSizeInKB = getLocalStorageSizeInKB();

                                                    // Cachegröße begrenzen
                                                    if (storageSizeInKB + itemSizeInKB > 8000) {
                                                        ladriverMessagesCache.shift(); // ältesten Eintrag löschen
                                                    }

                                                    try {
                                                        localStorage.setItem("ladriver-messages-cache", JSON.stringify(ladriverMessagesCache));
                                                    } catch (err) {
                                                        localStorage.removeItem("ladriver-messages-cache");
                                                    }
                                                }
                                            } else {
                                                console.error("HTTP Error", response.status, await response.text());
                                            }
                                        } catch (error) {
                                            console.error("Request failed", error);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                break;
        }
    } catch (err) {
        console.log('fMessageCache: ' + err.message);
    }

    return sResult;
}


 